import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { MainIconAnimated } from 'components/molecules';

// NOTE: needed to calculate relative position of icons
const iconWidth = 50;
const iconHeight = 125;

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 620,
    position: 'relative',
    overflow: 'hidden',
    backgroundImage:
      // "linear-gradient(to top, rgba(0,0,0,0), rgba(0,0,0,0) 50%, #fff 90%, #fff 90%), url('/assets/images/home-cover.jpg')",
      "url('/assets/images/home-cover.jpg')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  image: {
    height: 620,
    objectFit: 'cover',
  },
  iconTop: {
    position: 'relative',
    top: '20%',
    left: `calc(0% - ${iconWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      top: '10%',
      left: `calc(0% - ${iconWidth}px)`,
    },
  },
  iconLeft: {
    position: 'relative',
    top: `calc(20% + ${iconHeight}px)`,
    left: `calc(-15% - ${iconWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      left: `calc(-25% - ${iconWidth}px)`,
    },
  },
  iconRight: {
    position: 'relative',
    top: `calc(20% + ${iconHeight}px)`,
    left: `calc(15% - ${iconWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      left: `calc(25% - ${iconWidth}px)`,
    },
  },
  iconBottom: {
    position: 'relative',
    top: `calc(20% + ${2 * iconHeight}px)`,
    left: `calc(0% - ${iconWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      top: `calc(30% + ${2 * iconHeight}px)`,
    },
  },
}));

const Hero = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const { t } = useTranslation();

  const history = useHistory();
  const handleMainIconClick = useCallback(({ path }) => history.push(path), [
    history,
  ]);

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div className={classes.iconTop}>
        <MainIconAnimated
          path="/legislation"
          svgUrl="assets/icons/legislation.svg"
          text={t('HOME_PAGE.LEGISLATION')}
          onClick={handleMainIconClick}
        />
      </div>
      <div className={classes.iconLeft}>
        <MainIconAnimated
          path="/budget"
          svgUrl="assets/icons/budget.svg"
          text={t('HOME_PAGE.BUDGET')}
          onClick={handleMainIconClick}
        />
      </div>
      <div className={classes.iconRight}>
        <MainIconAnimated
          path="/national-indicators"
          svgUrl="assets/icons/statistics.svg"
          text={t(isSm ? 'HOME_PAGE.STATISTICS_HERO' : 'HOME_PAGE.STATISTICS')}
          onClick={handleMainIconClick}
        />
      </div>
      <div className={classes.iconBottom}>
        <MainIconAnimated
          path="/reports"
          svgUrl="assets/icons/reports.svg"
          text={t('HOME_PAGE.REPORTS')}
          onClick={handleMainIconClick}
        />
      </div>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
